/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ created: NonNullable<unknown>, updated: NonNullable<unknown>, failed: NonNullable<unknown> }} Jobs_Result_CommitInputs */

const cs_jobs_result_commit = /** @type {(inputs: Jobs_Result_CommitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vytvořeno ${i?.created} · aktualizováno ${i?.updated} · chyby ${i?.failed}`)
};

const en_jobs_result_commit = /** @type {(inputs: Jobs_Result_CommitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created ${i?.created} · updated ${i?.updated} · errors ${i?.failed}`)
};

/**
* | output |
* | --- |
* | "Created {created} · updated {updated} · errors {failed}" |
*
* @param {Jobs_Result_CommitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_result_commit = /** @type {((inputs: Jobs_Result_CommitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Result_CommitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_result_commit(inputs)
	return cs_jobs_result_commit(inputs)
});